<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/oKBUn4/tc-custom/scover.jpg?1651506940473" alt="This image is the cover for the book The Third Team: NFL Officials. Their Lives, Their Stories"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Third Team: NFL Officials. Their Lives, Their Stories
      </h1>
      <p class="bookDescription body article font2">
        <b>The only third-person account describing the lives and work of NFL game officials.</b><br/><br/>There would be no NFL football without him.<br/><br/>He is an accountant, educator, lawyer, sales executive, policeman, dentist, business owner, corporate executive, or fireman.<br/><br/>He is an NFL game official.<br/><br/>His life is a little like Clark Kent's; he lives a mainstream life Monday through Friday. On Sunday he puts on a uniform lending impressive power. He makes decisions affecting lives, careers, and fortunes. On his best day he is anonymous and unappreciated; on his worst, he is despised. He does a job from which fans, coaches, players, and even he himself demand perfection. He will never achieve it. Though having an essential part in a popular game, he prefers a low profile. His anonymity evokes curiosity about who he really is.<br/><br/>The Third Team takes stories and reflections from interviews with 25 past and current National Football League officials, including some among football's greatest, to give the reader a look into a job that is far more exacting than even the most astute fan appreciates. The stories reveal the kind of person who reaches the pinnacle. Though competitive, wanting to be the best among peers, each man recognizes that his crew s performance has higher value than individual achievement. Becoming a team player will bond each crewmember into a powerful brotherhood.<br/><br/>Their stories ranging from humorous to poignant give the reader insight into those working to keep NFL playing fields level for both teams. The perspectives are complemented by observations from former NFL coaches Tony Dungy, Steve Mariucci, Herman Edwards, and Jerry Glanville along with former player and current television analyst Matt Millen.<br/><br/>The Third Team will appeal to the fan who is interested in the game's inner workings and who will appreciate stories from behind the scenes and inside the country’s most popular spectator sport.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Richard Lister
      </h2>
      
      <p class="authorDescription body article">Since his youth. Richard Lister has loved football. Intrigued by work of NFL game officials, he took his curiosity in hand and devoted more than two years interviewing officials and people associated with the NFL. From that work, he shares the personal stories and anecdotes from NFL referees and officiating crew members.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6caf23c6